import { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../locales';
import images from '../../../images';
import Lesson from '../../../common/Lesson';
import { trackEvent } from '../../../helpers/common';
import events from '../../../app/events';
import CustomButton from '../../../common/CustomButton';

const Container = styled.div`
  padding: 25px 0px;
  padding-right: 0;
`;

const Content = styled.ul`
  min-height: 100px;
  overflow-x: scroll;
  display: flex;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: center;
  margin-right: -12px;
  margin-left: -12px;
  padding-left: 12px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Title = styled.h2`
  font-weight: bold;
  margin-bottom: 10px;
`;

const BodyText = styled.p`
  margin-bottom: 5px;
`;

const TakeTheQuizContainer = styled.div`
  display: block;
  padding: 10px 0;
`;

const SectionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Done = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
  margin-right: 8px;
  margin-top: 4px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url(${images.done});
`;

const MisunderstoodMaterials = ({
  lessons,
  quizData,
  hasPassedMmQuiz,
  accountId,
  viewedMuisunderstoodMaterials
}) => {
  const { push } = useHistory();
  const lessonRef = useRef();
  const { mumQuiz } = quizData || {};
  const lessonContentRef = useRef();

  const onClick = (id) => {
    trackEvent(events.DZ_HOME_MM_ITEM_TAP);
    push(`/lesson-details/mum/${id}`);
  };

  const resumeQuiz = () => {
    const nextIndex = Object
      .keys(mumQuiz)
      .map((key) => mumQuiz[key])
      .findIndex(({ answered }) => !answered);
    trackEvent(events.DZ_MM_TAKE_QUIZ_CTA_TAP);
    push(`/quiz/mum/${(nextIndex === -1) ? 0 : nextIndex}`);
  };

  const didCompleteLessons = Object
    .keys(lessons)
    .map((key) => lessons[key])
    .every(({ done }) => done)
    || (window.badges && window.badges.find(({ name }) => name === 'dz_misunderstood_materials')?.acquired);

  const didCompleteQuiz = (window.badges && window.badges.find(({ name }) => name === 'dz_misunderstood_materials')?.acquired) || hasPassedMmQuiz || mumQuiz
    .every(({ answered }) => answered);

  return (
    <Container>
      <SectionTitleContainer>
        <Title
          style={{
            fontSize: didCompleteLessons && didCompleteQuiz ? 19 : 24
          }}
        >
          {__('app.misunderstood_materials')}
        </Title>
        {
          didCompleteLessons
          && didCompleteQuiz
          && (
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
              <Done />
              <h2
                style={{
                  fontSize: 18,
                  color: process.env.REACT_APP_COLOR_RC_GREEN
                }}
              >
                {__('app.completed')}
              </h2>
            </div>
          )
        }
      </SectionTitleContainer>
      <BodyText>
        {__('app.ten_items_your_municipality_wishes_you_know')}
      </BodyText>
      {
        lessons
          ? (
            <Content aria-label="Miunderstood materials list" ref={lessonContentRef}>
              {
                Object
                  .keys(lessons)
                  .map((key) => lessons[key])
                  .sort((a, b) => viewedMuisunderstoodMaterials.includes(a?.id)
                    - viewedMuisunderstoodMaterials.includes(b?.id))
                  .map(({
                    id,
                    materialName,
                    header,
                    oidx,
                    done
                  }) => (
                    <Lesson
                      key={id}
                      id={id}
                      title={materialName}
                      description={header}
                      onClick={() => onClick(id)}
                      status={done ? 'done' : 'ready'}
                      data={lessons}
                      oidx={oidx}
                      type="MM"
                      ref={lessonRef}
                    />
                  ))
              }
            </Content>
          ) : null
      }
      {
        lessons
          && mumQuiz
          && didCompleteLessons
          && !hasPassedMmQuiz
          && accountId
          ? (
            <TakeTheQuizContainer>
              <CustomButton
                type="button"
                className="btn filled royal"
                onClick={resumeQuiz}
              >
                {__('app.take_the_quiz')}
              </CustomButton>
            </TakeTheQuizContainer>
          ) : null
      }
    </Container>
  );
};

export default MisunderstoodMaterials;
